
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoCampaignGrid extends Serenity.EntityGrid<PsPromoCampaignRow, any> {
        protected getColumnsKey() { return PsPromoCampaignColumns.columnsKey; }
        protected getDialogType() { return PsPromoCampaignDialog; }
        protected getIdProperty() { return PsPromoCampaignRow.idProperty; }
        protected getInsertPermission() { return PsPromoCampaignRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoCampaignRow.localTextPrefix; }
        protected getService() { return PsPromoCampaignService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        
    }
}